import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LandingPageTemplateDetails = lazy(() =>
  import("@scenes/MessageComposition/LandingPages/LandingPageTemplateDetails").then((module) => ({
    default: module.LandingPageTemplateDetails,
  }))
);

export const landingPageTemplateDetailsNRO: NavigationRoutingObject = {
  section: "templates",
  Component: LandingPageTemplateDetails,
  componentFeatureFlippers: ["landing_pages"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("landing-page-template-details-nro-heading", "Landing Page Template Details"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("landing_pages") &&
      hasPermission("appGroupOrAnyTeamInAppGroup", {
        permission: "viewLandingPageTemplates",
      })
    );
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/landing_page_templates/:appGroupId",
};
